import React, { Fragment } from 'react'
import AntDesign from 'styles/extra/ant-design/ant-design'
import AntDesignDatePicker from 'styles/extra/ant-design/ant-design-date-picker'
import AntDesignMotion from 'styles/extra/ant-design/ant-design-motion'
import AntDesignCommon from 'styles/extra/ant-design/common'

export default () => (
  <Fragment>
    <AntDesign />
    <AntDesignDatePicker />
    <AntDesignMotion />
    <AntDesignCommon />
  </Fragment>
)
